import { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./DetailsFormModal.css";
import { supabase } from "../../apis/supabaseClient";
import { useAuth } from "../../hooks/useAuth";

function DetailsFormModal({ show, setShow, setIsRegistered, accountId }) {
  const { user } = useAuth();
  const [focusedField, setFocusedField] = useState(null);
  const [userName, setUserName] = useState("");
  const [childName, setChildName] = useState("");
  const [childAge, setChildAge] = useState("");
  const [childGender, setChildGender] = useState("");
  const [errors, setErrors] = useState({});

const handleSaveDetails = async (e) => {
  e.preventDefault();
  const newErrors = {};

  if (!userName) newErrors.userName = true;
  if (!childAge) newErrors.childAge = true;
  if (!childName) newErrors.childName = true;
  if (!childGender) newErrors.childGender = true;

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }

  setErrors({});

  if (!user) {
    alert("No user logged in");
    return;
  }

  const userId = user.id;

  const { error: updateUserError } = await supabase
    .from("users")
    .update({ name: userName })
    .eq("user_id", userId);

  if (updateUserError) {
    alert("Failed to update user name");
    return;
  }

  const { error: upsertChildError } = await supabase
    .from("children")
    .upsert({
      account_id: accountId,
      name: childName,
      age: childAge,
      gender: childGender,
    }, { onConflict: ['account_id'] });

  if (upsertChildError) {
    alert("Failed to save child details: " + upsertChildError.message);
    return;
  }
  
  setIsRegistered(true);
  setShow(false);
};


  return (
    <>
      <Modal
        show={show}
        centered
        dialogClassName="custom-modal"
        data-bs-theme="light"
        size="lg"
      >
        <Modal.Header>
          <div style={{ width: "100%", textAlign: "center" }}>
            <Modal.Title
              style={{
                lineHeight: "1.2",
                marginBottom: "0px",
                fontSize: "2rem",
              }}
            >
              Details
            </Modal.Title>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="sub-header">
            <span className="sub-header-text">
              Please provide details for us to personalise content
            </span>
          </div>
          <Form>
            <Form.Group className="mb-2" controlId="userName">
              <Form.Label>Parent's Name</Form.Label>

              <Form.Control
                type="text"
                onFocus={() => setFocusedField("userName")}
                onBlur={() => setFocusedField(null)}
                name="childName"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                className={errors.userName ? "input-error" : ""}
              />
              <span
                style={{
                  display: "block",
                  fontSize: "0.875rem",
                  height: "1rem",
                  color: "gray",
                  paddingTop: "0.25rem",
                  paddingBottom: "0.25rem",
                  opacity: focusedField === "userName" ? 1 : 0,
                  transition: "opacity 0.2s ease",
                }}
              >
                How would you like us to refer to you as?
              </span>
            </Form.Group>
            <Form.Group className="mb-2" controlId="childName">
              <Form.Label>Child's Name</Form.Label>

              <Form.Control
                type="text"
                onFocus={() => setFocusedField("childName")}
                onBlur={() => setFocusedField(null)}
                name="childName"
                value={childName}
                onChange={(e) => setChildName(e.target.value)}
                className={errors.childName ? "input-error" : ""}
              />
              <span
                style={{
                  display: "block",
                  fontSize: "0.875rem",
                  height: "1rem",
                  color: "gray",
                  paddingTop: "0.25rem",
                  paddingBottom: "0.25rem",
                  opacity: focusedField === "childName" ? 1 : 0,
                  transition: "opacity 0.2s ease",
                }}
              >
                What can we call your child? (Nickname works!)
              </span>
            </Form.Group>

            <Form.Group className="mb-2" controlId="childAge">
              <Form.Label>Child's Age</Form.Label>
              <Form.Control
                type="text"
                onFocus={() => setFocusedField("childAge")}
                onBlur={() => setFocusedField(null)}
                name="childAge"
                value={childAge}
                onChange={(e) => setChildAge(e.target.value)}
                className={errors.childAge ? "input-error" : ""}
              />
              <span
                style={{
                  display: "block",
                  fontSize: "0.875rem",
                  whiteSpace: "nowrap",
                  height: "1rem",
                  color: "gray",
                  paddingTop: "0.25rem",
                  paddingBottom: "0.25rem",
                  opacity: focusedField === "childAge" ? 1 : 0,
                  transition: "opacity 0.2s ease",
                }}
              >
                Made with love for 5-8 yr olds
              </span>
            </Form.Group>

            <Form.Group className="mb-2" controlId="childGender">
              <Form.Label>Child's Gender</Form.Label>
              <Form.Control
                as="select"
                onFocus={() => setFocusedField("childGender")}
                onBlur={() => setFocusedField(null)}
                name="childGender"
                value={childGender}
                onChange={(e) => setChildGender(e.target.value)}
                className={errors.childGender ? "input-error" : ""}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </Form.Control>
              <span
                style={{
                  display: "block",
                  fontSize: "0.875rem",
                  height: "2rem",
                  color: "gray",
                  paddingTop: "0.25rem",
                  paddingBottom: "0.25rem",
                  opacity: focusedField === "childGender" ? 1 : 0,
                  transition: "opacity 0.2s ease",
                }}
              >
                Help us refer to your child correctly.
              </span>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="w-100 mb-3 d-flex justify-content-center">
          <Button onClick={handleSaveDetails} className="submit-button">
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DetailsFormModal;
